// core/services/estado-atencion.service.ts
import { Injectable } from '@angular/core';
import { EstadoDashboard } from '../../pages/pacientes/pacientes';

const STORAGE_KEY = 'estadosAtenciones';

@Injectable({ providedIn: 'root' })
export class EstadoAtencionService {
  private estados = new Map<string, EstadoDashboard>();

  constructor() {
    this.cargarDesdeStorage();
  }

  private cargarDesdeStorage(): void {
    const guardado = localStorage.getItem(STORAGE_KEY);
    if (!guardado) return;

    try {
      this.estados = new Map(Object.entries(JSON.parse(guardado)));
    } catch {
      this.estados = new Map();
    }
  }

  private guardarEnStorage(): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Object.fromEntries(this.estados)));
  }

  obtenerEstado(atencionId: string): EstadoDashboard {
    return this.estados.get(atencionId) ?? 'EN_ESPERA';
  }

  setEstado(atencionId: string, estado: EstadoDashboard): void {
    this.estados.set(atencionId, estado);
    this.guardarEnStorage();
  }

  eliminarEstado(atencionId: string): void {
    this.estados.delete(atencionId);
    this.guardarEnStorage();
  }
}
